// Replaces js/src/validator.js. Same public shape, cleaner internals.

const ZIP_RE = /^\d{5}$/;

export function validateQuery(query) {
  return typeof query === 'string' && ZIP_RE.test(query);
}

export function validateOptions(options) {
  if (!options || typeof options !== 'object') return false;
  if (typeof options.api_endpoint !== 'string' || options.api_endpoint === '') return false;
  if (typeof options.api_key !== 'string' || options.api_key === '') return false;
  return true;
}
